import { render, staticRenderFns } from "./WeekSelection.vue?vue&type=template&id=6cadaba2&scoped=true"
import script from "./WeekSelection.vue?vue&type=script&lang=js"
export * from "./WeekSelection.vue?vue&type=script&lang=js"
import style0 from "./WeekSelection.vue?vue&type=style&index=0&id=6cadaba2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cadaba2",
  null
  
)

export default component.exports